import React from "react";
import { useTheme } from "@mui/styles";
import { Box, Typography, useMediaQuery } from "@mui/material";
import TopicsMobile from "./TopicsMobile";
import TopicsDesktop from "./TopicsDesktop";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  jsContainer: {
    display: "flex",
    flexDirection: { xs: "column" },
  },
  title2: {
    color: theme.palette.red.main,
    fontSize: { xs: "14px", md: "16px" },
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontFamily: theme.typography.montserrat.semibold,
  },
  jsTitle: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  subtitle: {
    mt: { xs: "11px", md: "16px", lg: "20px", xl: "26px" },
    maxWidth: { xs: "225px", md: "500px", lg: "600px", xl: "800px" },
    height: { xs: "72px", md: "74px", lg: "76px", xl: "79px" },
    fontFamily: theme.typography.montserrat.light,
    fontSize: { xs: "32px", md: "40px", lg: "50px", xl: "65px" },
    textAlign: { xs: "center" },
    lineHeight: { xs: "36px", md: "inherit" },
    color: theme.palette.white.main,
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  titleContainer: {
    mt: { xs: "40px", md: "50px", lg: "60px", xl: "75px" },
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
  span: {
    fontWeight: "bold",
  },
});

const CodingChallengeTopics = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const { title, subtitle } = useTranslation(pathname, "CodingChallengeTopics");

  return (
    <Box sx={classes.jsContainer}>
      <Box sx={classes.jsTitle}>
        <Box sx={classes.titleContainer}>
          {isMobile ? null : <div style={classes.line}></div>}
          <Typography sx={classes.title2}>{title}</Typography>
        </Box>
        <Typography sx={classes.subtitle}>
          <span style={classes.span}>{subtitle}</span>
        </Typography>
      </Box>

      {isMobile ? <TopicsMobile /> : <TopicsDesktop />}
    </Box>
  );
};

export default CodingChallengeTopics;
